import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Achizitii/ComenziFurnizorModels.cs ----------

export type PurchaseOrderStatus = 'Draft' | 'Trimisa' | 'PartiallyReceived' | 'FullyReceived' | 'Closed' | 'Cancelled'
export type PurchaseTransactionType = 'Local' | 'Intracomunitar' | 'Import'

export interface PurchaseOrderLine {
  id: string | null
  lineNumber: number
  articleId: string
  articleCode: string
  articleDescription: string
  quantity: number
  unitOfMeasureId: string
  unitOfMeasureCode: string
  unitPrice: number
  currency: string
  vatRateId: string | null
  vatRatePercent: number | null
  lineValue: number
  quantityReceived: number
  quantityRemaining: number
}

export type SavePurchaseOrderLinePayload = {
  articleId: string
  quantity: number
  unitOfMeasureId: string
  unitPrice: number | null
  vatRateId: string | null
}

export interface PurchaseOrderListItem {
  id: string
  number: string
  orderDate: string
  supplierId: string
  supplierName: string
  status: PurchaseOrderStatus
  requestedDeliveryDate: string
  isOverdue: boolean
  total: number
  currency: string
}

export interface PurchaseOrderDetail {
  id: string
  number: string
  orderDate: string
  supplierId: string
  supplierName: string
  deliveryWarehouseId: string
  deliveryWarehouseName: string
  deliveryAddress: string
  requestedDeliveryDate: string
  isOverdue: boolean
  paymentTerms: string | null
  currency: string
  transactionType: PurchaseTransactionType
  notes: string | null
  status: PurchaseOrderStatus
  sourcePurchaseRequestId: string | null
  sourceContractId: string | null
  lines: PurchaseOrderLine[]
  total: number
}

export interface SavePurchaseOrderPayload {
  supplierId: string
  deliveryWarehouseId: string
  requestedDeliveryDate: string
  paymentTerms: string | null
  currency: string
  transactionType: PurchaseTransactionType
  notes: string | null
  sourceContractId: string | null
  lines: SavePurchaseOrderLinePayload[]
}

export interface PriceHistoryEntry { date: string; price: number; currency: string; source: string }

export interface SuggestedPrice { price: number | null; currency: string | null; unitOfMeasureId: string | null; source: string }

export interface SupplierReturn { id: string; number: string; supplierId: string; supplierName: string; returnDate: string; reason: string; notes: string | null; hasCreditNote: boolean }
export interface SaveSupplierReturnLinePayload { goodsReceiptLineId: string; quantityReturned: number; reason: string | null }
export interface SaveSupplierReturnPayload { supplierId: string; returnDate: string; reason: string; notes: string | null; lines: SaveSupplierReturnLinePayload[] }

export const listPurchaseOrders = () => api.get<PurchaseOrderListItem[]>('/achizitii/comenzi').then((r) => r.data)
export const getPurchaseOrder = (id: string) => api.get<PurchaseOrderDetail>(`/achizitii/comenzi/${id}`).then((r) => r.data)
export const createPurchaseOrder = (payload: SavePurchaseOrderPayload) =>
  api.post<{ id: string }>('/achizitii/comenzi', payload).then((r) => r.data)
export const updatePurchaseOrder = (id: string, payload: SavePurchaseOrderPayload) => api.put(`/achizitii/comenzi/${id}`, payload)
export const sendPurchaseOrder = (id: string) => api.post(`/achizitii/comenzi/${id}/trimite`)
export const getPurchaseOrderDocumentHtml = (id: string) =>
  api.get<string>(`/achizitii/comenzi/${id}/document`, { responseType: 'text' }).then((r) => r.data)
export const cancelPurchaseOrder = (id: string) => api.post(`/achizitii/comenzi/${id}/anuleaza`)
export const getPriceHistory = (supplierId: string, articleId: string) =>
  api.get<PriceHistoryEntry[]>(`/achizitii/comenzi/istoric-preturi/${supplierId}/${articleId}`).then((r) => r.data)
export const getSuggestedPrice = (supplierId: string, articleId: string, contractId: string | null) =>
  api.get<SuggestedPrice>('/achizitii/comenzi/pret-sugerat', { params: { supplierId, articleId, contractId } }).then((r) => r.data)

export const listSupplierReturns = () => api.get<SupplierReturn[]>('/achizitii/comenzi/retururi').then((r) => r.data)
export const createSupplierReturn = (payload: SaveSupplierReturnPayload) =>
  api.post<{ id: string }>('/achizitii/comenzi/retururi', payload).then((r) => r.data)
export const createReturnCreditNote = (returnId: string) =>
  api.post<{ id: string }>(`/achizitii/comenzi/retururi/${returnId}/nota-credit`).then((r) => r.data)
